
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLufD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5o4s6 = parcelRequire("5o4s6");


var $3PNw6 = parcelRequire("3PNw6");










/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $7447827e68c12d6a$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $7447827e68c12d6a$export$fd536c918b58ab76 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let alt;
    let imageRef;
    let otherProps;
    let style;
    if ($[0] !== props) {
        ({ style: style, imageRef: imageRef, alt: alt, ...otherProps } = props);
        $[0] = props;
        $[1] = alt;
        $[2] = imageRef;
        $[3] = otherProps;
        $[4] = style;
    } else {
        alt = $[1];
        imageRef = $[2];
        otherProps = $[3];
        style = $[4];
    }
    let t0;
    if ($[5] !== style) {
        t0 = {
            ...$7447827e68c12d6a$var$imgStyle,
            ...style
        };
        $[5] = style;
        $[6] = t0;
    } else t0 = $[6];
    let t1;
    if ($[7] !== alt || $[8] !== imageRef || $[9] !== otherProps || $[10] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            ...otherProps,
            alt: alt,
            ref: imageRef,
            style: t0
        });
        $[7] = alt;
        $[8] = imageRef;
        $[9] = otherProps;
        $[10] = t0;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : (props)=>{
    const { style: style, imageRef: imageRef, alt: alt, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        ...otherProps,
        alt: alt,
        ref: imageRef,
        style: {
            ...$7447827e68c12d6a$var$imgStyle,
            ...style
        }
    }));
};



var $3Seye = parcelRequire("3Seye");


var $2VwyL = parcelRequire("2VwyL");

const $b717b07d1b7a6335$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { dataURI: dataURI, alt: t1, crop: t2, stretch: t3, previewOrientation: t4, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: t5 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const crop = t2 === undefined ? false : t2;
    const stretch = t3 === undefined ? false : t3;
    const previewOrientation = t4 === undefined ? 1 : t4;
    const forceSyncDisplay = t5 === undefined ? false : t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            width: Infinity,
            height: Infinity
        };
        $[0] = t6;
    } else t6 = $[0];
    const [t7, setParentDimensions] = (0, $cozmU.useState)(t6);
    const { width: parentWidth, height: parentHeight } = t7;
    let t8;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            width: 0,
            height: 0
        };
        $[1] = t8;
    } else t8 = $[1];
    const [t9, setImageDimensions] = (0, $cozmU.useState)(t8);
    const { width: imgWidth, height: imgHeight } = t9;
    const [isImageLoaded, setIsImageLoaded] = (0, $cozmU.useState)(false);
    const imgRef = (0, $cozmU.useRef)(null);
    let t10;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (imgElem)=>{
            if (!imgElem || imgRef.current) return;
            if (imgElem.parentElement) {
                const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
                setParentDimensions({
                    width: width,
                    height: height
                });
            }
            imgRef.current = imgElem;
        };
        $[2] = t10;
    } else t10 = $[2];
    const imageRef = t10;
    let t11;
    if ($[3] !== ref) {
        t11 = [
            imageRef,
            ref
        ];
        $[3] = ref;
        $[4] = t11;
    } else t11 = $[4];
    const mergedRef = (0, $2VwyL.useMergeRefs)(t11);
    let t12;
    if ($[5] !== onImageLoad) {
        t12 = (e)=>{
            if (!imgRef.current) return;
            setImageDimensions({
                width: imgRef.current.naturalWidth,
                height: imgRef.current.naturalHeight
            });
            setIsImageLoaded(true);
            onImageLoad?.(e.currentTarget);
        };
        $[5] = onImageLoad;
        $[6] = t12;
    } else t12 = $[6];
    const imageLoadHandler = t12;
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = "100%";
    const isCoverStrategy = crop;
    const isFitStrategy = !crop;
    let t13;
    if ($[7] !== previewOrientation) {
        t13 = previewOrientation !== "from-image" && (0, $3Seye.isRotated)(previewOrientation);
        $[7] = previewOrientation;
        $[8] = t13;
    } else t13 = $[8];
    const isImageRotated = t13;
    if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    const isStretchingAllowed = stretch;
    const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    let style;
    if ($[9] !== dataURI || $[10] !== isCoverStrategy || $[11] !== isFitStrategy || $[12] !== isImageMoreLandscapyThanContainer || $[13] !== isStretchingAllowed || $[14] !== percentSize || $[15] !== previewOrientation || $[16] !== showImage) {
        style = {
            transform: "translate(-50%, -50%)"
        };
        if (isStretchingAllowed) {
            if (isFitStrategy && isImageMoreLandscapyThanContainer) style.width = percentSize;
            else if (isFitStrategy && !isImageMoreLandscapyThanContainer) style.height = percentSize;
            else {
                if (isCoverStrategy && isImageMoreLandscapyThanContainer) style.height = percentSize;
                else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
            }
        } else if (isFitStrategy) {
            style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else {
            if (isCoverStrategy && isImageMoreLandscapyThanContainer) style.maxHeight = percentSize;
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
        }
        if (!showImage || !dataURI) style.display = "none";
        if (previewOrientation === "from-image") style.imageOrientation = "from-image";
        else if (previewOrientation > 1) {
            let t14;
            if ($[18] !== previewOrientation) {
                t14 = (0, $3Seye.getCssFromImageOrientation)(previewOrientation);
                $[18] = previewOrientation;
                $[19] = t14;
            } else t14 = $[19];
            const transform = t14;
            style.transform = style.transform + ` ${transform}`;
        }
        $[9] = dataURI;
        $[10] = isCoverStrategy;
        $[11] = isFitStrategy;
        $[12] = isImageMoreLandscapyThanContainer;
        $[13] = isStretchingAllowed;
        $[14] = percentSize;
        $[15] = previewOrientation;
        $[16] = showImage;
        $[17] = style;
    } else style = $[17];
    let t14;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                hasMediaComponent: true
            }
        });
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== alt || $[22] !== crossOrigin || $[23] !== dataURI || $[24] !== imageLoadHandler || $[25] !== loading || $[26] !== mergedRef || $[27] !== onImageError || $[28] !== style) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7447827e68c12d6a$export$fd536c918b58ab76), {
            loading: loading,
            "data-testid": "media-image",
            "data-vc": "media-image",
            draggable: false,
            alt: alt,
            style: style,
            onLoad: imageLoadHandler,
            onError: onImageError,
            imageRef: mergedRef,
            src: dataURI,
            crossOrigin: crossOrigin,
            ...(0, $5o4s6.VcMediaWrapperProps)
        }));
        $[21] = alt;
        $[22] = crossOrigin;
        $[23] = dataURI;
        $[24] = imageLoadHandler;
        $[25] = loading;
        $[26] = mergedRef;
        $[27] = onImageError;
        $[28] = style;
        $[29] = t15;
    } else t15 = $[29];
    return t15;
} : ({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $cozmU.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $cozmU.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $cozmU.useState)(false);
    const imgRef = (0, $cozmU.useRef)(null);
    const imageRef = (0, $cozmU.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:
          Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:
              Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $3Seye.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:
       Example #1:
       Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘
       Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6
       To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.
       In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true
       According to this variables state css will become:
        height: 100%;
       Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.
       ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.
       And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:
       ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘
       To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)
       New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px
       ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘
       Unfortunately this is not over yet.
  
      Example #2:
       Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6
       Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true
        According to this variables state css will become:
        width: 100%;
       FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.
       ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.
       Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘
       This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%
       New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px
       So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:
         Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|
       For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
            Image matches its width to container's and height scales accordingly.
               Image       Container       Result
                         ┌─────────┐    ┌─────────┐
             ┌──────┐    │         │    ├─────────┤
             │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
             │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
             └──────┘    │         │    ├─────────┤
                         └─────────┘    └─────────┘
           */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
            Image matches its height to container's and width scales accordingly.
           */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
            In order to cover whole container guaranteed (even in expense of stretching)
            image matches its height to container's. Width scales accordingly and crops out sides.
                Image       Container    Result (░ - is what cropped out)
                         ┌─────────┐    ┌──┬──────┬──┐
             ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
             │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
             │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
             └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                         └─────────┘    └──┴──────┴──┘
           */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
            We want image to be as wide and as height as container but not bigger then it's own size.
               Image       Container       Result
             ┌───────────┐    ┌─────────┐    ┌─────────┐
             │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
             │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
             │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
             └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                              │         │    ├─────────┤
                              └─────────┘    └─────────┘
            And if image is smaller it doesn't change its size
               Image       Container       Result
                         ┌──────────┐    ┌──────────┐
                         │          │    │          │
             ┌──────┐    │          │    │ ┌──────┐ │
             │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
             │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
             └──────┘    │          │    │ └──────┘ │
                         │          │    │          │
                         └──────────┘    └──────────┘
           */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
            We want to fill container but we can't stretch an image if it's smaller then container.
               Image            Container       Result
             ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
             │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
             │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
             │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
             │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
             └────────────┘
            */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $3Seye.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7447827e68c12d6a$export$fd536c918b58ab76), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }));
});
module.exports["MediaImage"] = $b717b07d1b7a6335$export$1f97dc1e9d072692;

});


//# sourceMappingURL=cardWithMediaClient.675585cc.js.map
